import Github from "../../Images/icons/github_icon.png";
import Linked from "../../Images/icons/linked_icon.svg";
import Php from "../../Images/icons/php_icon.svg";
import Sass from "../../Images/icons/sass_icon.svg";
import Gmail from "../../Images/icons/gmail_icon.svg";
import Wordpress from "../../Images/icons/wordpress_icon.svg";
import Css from "../../Images/icons/css_icon.svg";
import Html from "../../Images/icons/html_icon.svg";
import Javascript from "../../Images/icons/javascript_icon.svg";
import Laravel from "../../Images/icons/laravel_icon.svg";
import React from "../../Images/icons/react_icon.svg";
import VueJs from "../../Images/icons/vuejs_icon.svg";
import Youtube from "../../Images/icons/youtube.png";
import MySql from "../../Images/icons/mySql_icon.svg";
import Instagram from "../../Images/icons/instagram.png";
import Facebook from "../../Images/icons/facebook.png";
import LinkedIn from "../../Images/icons/linkedin.png";
import Atomic from "../../Images/icons/atomicDesign.png";
import Figma from "../../Images/icons/figma.png";
import Illustrator from "../../Images/icons/illustrator.png";
import Photoshop from "../../Images/icons/photoshop.png";
import PremierePro from "../../Images/icons/premiere-pro.png";
import Xd from "../../Images/icons/xd.png";
import Tailwind from "../../Images/icons/tailwind.png";

const icons = {
  Github,
  Tailwind,
  Atomic,
  Figma,
  Illustrator,
  Photoshop,
  PremierePro,
  Xd,
  Gmail,
  Youtube,
  Linked,
  Instagram,
  Facebook,
  LinkedIn,
  Php,
  Sass,
  Wordpress,
  Css,
  Html,
  Javascript,
  Laravel,
  React,
  VueJs,
  MySql,
};

export default icons;
